const Store = {
   sizes: {
      width: window.innerWidth,
      height: window.innerHeight
   }
}

export default Store